import { QuestionnaireResponsePair } from "@/types/questionnaire/models"

export type QuestionAnswerState =
  | "answered"
  | "needs-answer"
  | "low-confidence"
  | "unanswered"

export type QuestionAnswerTone = QuestionAnswerState | "neutral"

const hasSelectedListValues = (value: string) => {
  try {
    const parsedValue = JSON.parse(value)

    if (!Array.isArray(parsedValue)) {
      return value.trim().length > 0
    }

    return parsedValue.some((item) => String(item ?? "").trim().length > 0)
  } catch {
    return value.trim().length > 0
  }
}

export const hasQuestionAnswerResponse = (
  responsePair: QuestionnaireResponsePair,
) => {
  const responseValue = responsePair.response?.trim() ?? ""

  if (responseValue.length === 0) {
    return false
  }

  if (responsePair.type === "multiple-select") {
    return hasSelectedListValues(responseValue)
  }

  return true
}

export const getQuestionAnswerState = (
  responsePair: QuestionnaireResponsePair,
): QuestionAnswerState => {
  if (!hasQuestionAnswerResponse(responsePair)) {
    return responsePair.creationSource === "manual"
      ? "needs-answer"
      : "unanswered"
  }

  if (responsePair.lowConfidence && !responsePair.manuallyEdited) {
    return "low-confidence"
  }

  return "answered"
}

export const getQuestionAnswerTone = (
  responsePair: QuestionnaireResponsePair,
): QuestionAnswerTone => {
  return getQuestionAnswerState(responsePair)
}

export const needsQuestionAnswerHelp = (
  responsePair: QuestionnaireResponsePair,
) => {
  return (
    !responsePair.manuallyEdited &&
    getQuestionAnswerState(responsePair) !== "answered"
  )
}
